export default "__VITE_ASSET__B7EeNcp8__"